// @flow

import React, { type Node } from 'react';
import { PaymentInfoContainer, PaymentInfoInnerContainer, PaymentInfoIcon, PaymentInfoText, H1 } from './shared-styled-components';
import { type PaymentInfoDisplayModel } from './payment-info-display-model';

type RenderPaymentProps = {
  h1Text: string,
  items: PaymentInfoDisplayModel,
  bgColor?: string,
}

export function RenderPaymentInfoContainer({h1Text, items, bgColor='#f9f9f9' }: RenderPaymentProps): Node {
  return (
    <PaymentInfoContainer bgColor={bgColor}>
      <H1>{h1Text}</H1>
      {items.map(({ imgSrc, subText, strong }, index) => {
        return (
          <PaymentInfoInnerContainer key={index}>
            <PaymentInfoIcon>
              <img src={imgSrc} alt="payment info icon" />
            </PaymentInfoIcon>
            <PaymentInfoText>
              {subText} <strong>{strong}</strong>
            </PaymentInfoText>
          </PaymentInfoInnerContainer>
        );
      })}
    </PaymentInfoContainer>
  );
}
